/**
 * Clickup linking is switched off in the UI for now; the fields, the
 * validation and the customer_project handling stay in place for when it
 * comes back. While it is off, `clickup_project_no` is surfaced on its own as
 * the optional "Projektnummer" -- which is why the schema keeps the Clickup
 * requirements off as well.
 */
export const SHOW_CLICKUP_LINK: boolean = false

/**
 * The recurring project kinds offered as a description, each with the short
 * form the hand-in name uses (see `buildHandInProjectName`). A description
 * typed by hand has no short form and goes into the name as written.
 */
export const DESCRIPTION_PRESETS: { description: string; abbreviation: string }[] = [
  { description: 'Neubau eines Einfamilienhauses', abbreviation: 'EFH' },
  { description: 'Neubau eines Mehrfamilienhauses', abbreviation: 'MFH' },
  { description: 'Neubau Nichtwohngebäude', abbreviation: 'Nichtwohngeb.' },
  { description: 'Bauen im Bestand', abbreviation: 'Bestand' },
]
